import { Info } from 'lucide-react';

export function HeroInfoBox({ title, text }) {
  if (!title && !text) return null;
  
  return (
    <div className="bg-[#FEF3C7] border border-[#F59E0B]/30 rounded-sm px-4 py-3 opacity-0 animate-fade-in-up animate-delay-50">
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-0.5" />
        <div>
          {title && (
            <p className="font-semibold text-[#92400E] text-sm">{title}</p>
          )}
          {text && (
            <p className="text-[#A16207] text-sm mt-0.5">{text}</p>
          )}
        </div>
      </div>
    </div>
  );
}
